export default __webpack_public_path__ + "static/media/google-authenticator-thumb.e1624b5f.png";